import React from 'react';
import { aspectFromMode, exploreAspectHint, type ExploreAspectMode } from '../../lib/exploreAspect';

const CHOICES: { id: ExploreAspectMode; label: string }[] = [
  { id: 'auto', label: 'Automático' },
  { id: 'horizontal', label: 'Horizontal' },
  { id: 'vertical', label: 'Vertical' },
];

export default function ExploreAspectField(props: {
  mode: ExploreAspectMode;
  templateAspect: string;
  sizes: { width: number; height: number }[];
  hasImages: boolean;
  disabled?: boolean;
  onChange: (mode: ExploreAspectMode) => void;
}) {
  const aspect = aspectFromMode(props.mode, props.sizes, props.templateAspect);
  const hint = props.mode === 'auto' && props.hasImages && props.sizes.length === 0
    ? 'A proporção segue as fotos que você enviar.'
    : exploreAspectHint(props.mode, aspect, props.templateAspect, props.hasImages && props.sizes.length > 0);
  return (
    <div className="ex-field explore-aspect">
      <span id="explore-aspect-label" className="ex-field-label">Proporção do vídeo</span>
      <div className="explore-seg is-fill" role="group" aria-labelledby="explore-aspect-label">
        {CHOICES.map((opt) => (
          <button
            key={opt.id}
            type="button"
            aria-pressed={props.mode === opt.id}
            disabled={props.disabled}
            className={props.mode === opt.id ? 'is-on' : undefined}
            onClick={() => props.onChange(opt.id)}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <p className="explore-note">{hint}</p>
    </div>
  );
}
